import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import { msalResult, loginRequest } from "../../authConfig";

export const SignInButton = (name: any) => {
    const { instance } = useMsal();
    const isLocalhost = window.location.hostname === "localhost";
    const { theme } = msalResult;

    // Set redirectUri conditionally based on whether on localhost or not
    // SECURITY FIX: Use current origin instead of hardcoded URLs
    if (isLocalhost) {
        const localOrigin = window.location.origin;
        instance.getConfiguration().auth.redirectUri = localOrigin;
        instance.getConfiguration().auth.postLogoutRedirectUri = localOrigin;
    };

    const handleLogin = async () => {
        // Only use redirect for most reliable experience across browsers
        try {
            // FIX: Use loginRequest for login, not tokenRequest
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            // Silent error handling
        }
    }

    return (
        <div>
            <Button 
                style={{
                    textTransform:'none', 
                    fontFamily: theme?.Style?.font, 
                    padding: '8px 12px', 
                    fontSize:'1.2rem', 
                    lineHeight:'1rem'
                }} 
                onClick={handleLogin} 
                color="inherit"
            > 
                {name.name} 
            </Button>
        </div>
    )
}